// External
import React from 'react';
import PropTypes from 'prop-types';

// Internal
import { Text, Container } from '@iclinic/iclinic-ui';
import style from './ViewSuccess.scss';

const ViewSuccess = ({ email, title, productName, alt, imageUrl }) => (
  <div className={style.view}>
    <h2 className={style.view__title}>{title}</h2>
    <div data-section="body" className="muted">
      <Text className={style.view__description}>
        <p>
          {`Esse foi um grande passo para ter mais sucesso em sua clínica!
          Agora é só aproveitar as funcionalidades do plano ${productName}.`}
        </p>
      </Text>
      <Text className={style.view__description}>
        <p>
          Para que os demais usuários também tenham acesso ao novo plano, eles
          só precisam clicar em “ativar recursos” na barra de avisos do sistema.
        </p>
      </Text>
      <Text className={style.view__description}>
        <p>
          Você receberá o comprovante desta assinatura e outras informações no
          e-mail <strong>{email}</strong>.
        </p>
      </Text>
      <Text className={style.view__description}>
        <p>{`Veja as instruções para melhor utilizar seu plano ${productName}.`}</p>
      </Text>
      <Container alignContent="center">
        <img className={style.view__image} src={imageUrl} alt={alt} />
      </Container>
    </div>
  </div>
);

ViewSuccess.propTypes = {
  email: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ViewSuccess;
